import { useState, useEffect } from 'react';

const heroImages = [
  {
    src: "https://readdy.ai/api/search-image?query=majestic%20african%20king%20mansa%20musa%20wearing%20ornate%20golden%20crown%20with%20intricate%20details%2C%20regal%20portrait%2C%20powerful%20dignified%20expression%2C%20rich%20golden%20jewelry%20and%20royal%20garments%2C%20dramatic%20cinematic%20lighting%2C%20dark%20sophisticated%20background%2C%20symbol%20of%20prosperity%20and%20wealth%2C%20historical%20grandeur%2C%20professional%20studio%20photography%2C%20high%20contrast%2C%20elegant%20composition%2C%20cultural%20heritage%20and%20power&width=1920&height=1080&seq=hero-mansa-musa-king-portrait&orientation=landscape",
    alt: "Mansa Musa JH - Prosperidade Ancestral"
  },
  {
    src: "https://readdy.ai/api/search-image?query=young%20black%20boys%20playing%20soccer%20football%20in%20brazilian%20favela%20community%20wearing%20golden%20crowns%20as%20kings%2C%20energetic%20action%20scene%2C%20children%20running%20with%20ball%2C%20colorful%20favela%20houses%20in%20background%2C%20authentic%20street%20soccer%20culture%2C%20joyful%20expressions%2C%20golden%20hour%20dramatic%20lighting%2C%20urban%20community%20life%2C%20cultural%20pride%20and%20childhood%20dreams%2C%20documentary%20style%20photography%2C%20vibrant%20atmosphere%2C%20symbol%20of%20hope%20and%20royalty%20in%20periphery%2C%20realistic%20and%20inspiring%20scene%20with%20golden%20tones&width=1920&height=1080&seq=hero-favela-boys-soccer-kings-crown&orientation=landscape",
    alt: "Mansa Musa JH - Reis da Favela"
  },
  {
    src: "https://readdy.ai/api/search-image?query=powerful%20african%20community%20leaders%20standing%20together%20in%20urban%20peripheral%20neighborhood%2C%20golden%20hour%20sunset%20light%20casting%20warm%20tones%2C%20group%20of%20diverse%20young%20people%20with%20confident%20expressions%2C%20street%20art%20murals%20in%20background%2C%20cultural%20entrepreneurship%20and%20social%20impact%2C%20dramatic%20lighting%20with%20golden%20and%20dark%20tones%2C%20documentary%20style%20photography%2C%20strength%20and%20resilience%2C%20community%20transformation%20and%20empowerment&width=1920&height=1080&seq=hero-community-leaders-urban-impact&orientation=landscape",
    alt: "Mansa Musa JH - Impacto Social"
  }
];

export function Hero() {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {heroImages.map((image, index) => (
        <div
          key={index}
          className="absolute inset-0 transition-opacity duration-[1500ms] ease-in-out"
          style={{ opacity: currentImage === index ? 1 : 0 }}
        >
          <img
            src={image.src}
            alt={image.alt}
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      {/* Slide indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-3">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImage(index)}
            className={`h-1.5 rounded-full transition-all duration-500 cursor-pointer ${
              currentImage === index
                ? "w-10 bg-gold"
                : "w-4 bg-white/40 hover:bg-white/60"
            }`}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-8 lg:px-20 py-20 sm:py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          <div className="space-y-6 sm:space-y-8">
            <div className="space-y-3 sm:space-y-4">
              <h1 className="font-display font-extrabold text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl leading-[1.1] tracking-tight">
                <span className="text-gold">Prosperidade</span>
                <br />
                <span className="text-white">é ancestral.</span>
                <br />
                <span className="text-gold">Execução</span>
                <br />
                <span className="text-white">é contemporânea.</span>
              </h1>
            </div>

            <p className="text-sm sm:text-base lg:text-lg text-gray-300 max-w-xl leading-relaxed font-light">
              A Mansa Musa JH estrutura, executa e potencializa projetos culturais de
              impacto social e econômico em territórios periféricos e urbanos.
            </p>

            <p className="text-base sm:text-lg lg:text-xl text-white font-medium">
              Transformamos cultura em organização, gestão e resultado.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-2 sm:pt-4">
              <button
                onClick={() => scrollToSection("projetos")}
                className="px-6 sm:px-8 py-3 sm:py-4 bg-transparent border-2 border-gold text-gold rounded-full text-xs sm:text-sm font-semibold uppercase tracking-wider hover:bg-gold hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Conheça nossos projetos
              </button>
              <button
                onClick={() => scrollToSection("contato")}
                className="px-6 sm:px-8 py-3 sm:py-4 bg-transparent border border-white text-white rounded-full text-xs sm:text-sm font-semibold uppercase tracking-wider hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Seja parceiro
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
